(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9466],{

/***/ 69755:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/address-entry-mobile",
      function () {
        return __webpack_require__(12267);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76614);
/* harmony import */ var _components_landing_pages_v2_Layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63203);
/* harmony import */ var _components_shared_NewSellerFlowAddressInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53143);





var trackingTaxonomy = "new_homepage";
/** Address entry screen to start the seller input flow in the mobile native app (via a web view) */ var AddressEntryMobile = function(param) {
    var header = param.header, footer = param.footer;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_landing_pages_v2_Layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        header: header !== null && header !== void 0 ? header : undefined,
        footer: footer !== null && footer !== void 0 ? footer : undefined,
        slug: "/address-entry-mobile",
        hideHeader: true,
        hideFooter: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
            py: "$8",
            px: "$8",
            gap: "$5",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                    typography: "$subheaderXsmall",
                    tag: "h4",
                    children: "Let’s start your offer"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                    typography: "$bodyMedium",
                    tag: "p",
                    children: "Enter your address to get started. This helps us find sales data for your home and other homes nearby."
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_shared_NewSellerFlowAddressInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    trackingTaxonomy: trackingTaxonomy,
                    inputLocation: "address-entry-mobile-page",
                    placeholder: "125 W Muriel Dr",
                    channel: "DEFAULT"
                })
            ]
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (AddressEntryMobile);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1176,3520,5527,6523,4468,9868,2345,7551,9086,4632,8764,8111,5177,5675,4522,4991,2681,6885,3203,9774,2888,179], function() { return __webpack_exec__(69755); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);